<div class="convert-dialog" [style.--scrollbar-thumb-color]="settingsData?.main_bg_color ? settingsData.main_bg_color + 'B3' : null"
[ngStyle]="{'background-color':settingsData?.form_bg_color}">
  
  <h2 mat-dialog-title class="dialog-title" [ngStyle]="{'color':settingsData?.form_font_secondary_color}">Convert tokens from {{targetToken==="KO+"?clientDetails?.name==="BigbeeAI"?"BB":targetToken:targetToken}} to {{selectedToken==="KO+"?clientDetails?.name==="BigbeeAI"?"BB":selectedToken:selectedToken}}</h2>
  
  <div mat-dialog-content class="dialog-content">
    <div class="balance-section" [ngStyle]="{'background-color':settingsData?.bg_secondary_color,'color':settingsData?.font_secondary_color}">
      <div class="balance-label">Available Balance:</div>
      <div class="token-balance">
        <div class="token-row">
          <span class="token-amount">{{koBalance}}</span>
          <span class="token-symbol">{{clientDetails.name=="BigbeeAI"?"BB":"KO+"}}</span>
        </div>
        <div class="token-row">
          <span class="token-amount">{{gflBalance}}</span>
          <span class="token-symbol">GFL</span>
        </div>
      </div>
    </div>
    
    <mat-form-field class="token-input" [style.--form-border-color]="settingsData?.form_font_secondary_color">
      <mat-label [ngStyle]="{'color':settingsData?.form_font_secondary_color}">Enter number of tokens to convert</mat-label>
      <input matInput 
             type="number" 
             min="0.0001" 
             step="0.0001"
             [(ngModel)]="convertAmount" 
             (input)="onAmountChange()"
             required [style.color]="settingsData?.form_font_secondary_color +'!important'">
    </mat-form-field>
    <div class="error-message" *ngIf="errorMessage" [ngStyle]="{'background-color':settingsData?.bg_secondary_color,'color':settingsData?.font_secondary_color}">
      <mat-icon class="error-icon" [ngStyle]="{'color':settingsData?.font_secondary_color}">error_outline</mat-icon>
      {{errorMessage}}
    </div>
    <div class="conversion-message" *ngIf="convertAmount > 0 && !errorMessage" [ngStyle]="{'background-color':settingsData?.bg_secondary_color,'color':settingsData?.font_secondary_color}">
      {{sourceAmount | number:'1.4-4'}} {{  targetToken==="KO+"?clientDetails?.name==="BigbeeAI"?"BB":targetToken:targetToken}} will be converted to {{convertAmount | number:'1.4-4'}} {{selectedToken==="KO+"?clientDetails?.name==="BigbeeAI"?"BB":selectedToken:selectedToken}}
    </div>
  </div>
  
  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button  (click)="onCancel()" class="flat-secondary-button "
    [style.color]="settingsData?.bg_primary_color + '!important'"
     [style.border]="'1px solid ' + settingsData?.bg_primary_color"
     [style.background-color]="'#fff'+ ' !important'">Cancel</button>
    <button mat-flat-button
    [attr.style]="
  (settingsData?.bg_primary_color ? 'background-color: ' + settingsData?.bg_primary_color + ' !important; ' : '') +
  (settingsData?.font_primary_color ? 'color: ' + settingsData.font_primary_color + ' !important;' : '')
  "(click)="onConvert()" 
            [disabled]="!convertAmount || convertAmount <= 0 || isConverting || !enableConvert"
            class="flat-primary-button tertiary-bg-button"
            >
      Convert
    </button>
  </div>
</div>
